import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from '../Utils';


// Data Mapping
export function getViewManageDataMappings(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-data-mappings`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathViewDataMappingShforms(dmapId=null) {
  if (dmapId) {
      return `view/data-mapping-shforms/${dmapId}`;
  } else {
      return `view/data-mapping-shforms`;
  }
}

export function getViewDataMappingShforms(successCallback, errorCallback, dmapId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewDataMappingShforms(dmapId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathDataMappings(dmapId=null) {
  if (dmapId) {
      return `data-mappings/${dmapId}`;
  } else {
      return `data-mappings`;
  }
}

export function createDataMappings(successCallback, errorCallback, data) {
  postAuth({
    "path": pathDataMappings(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchDataMappings(successCallback, errorCallback, data, dmapId) {
  patchAuth({
    "path": pathDataMappings(dmapId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteDataMappings(successCallback, errorCallback, dmapId) {
  deleteAuth({
    "path": pathDataMappings(dmapId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}



// CSV Schema
export function getViewManageCsvSchemas(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-csv-schemas`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageCsvSchemaDetails(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-csv-schema-details`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postDownloadCsvSchemaTemplate(successCallback, errorCallback, key) {
  postAuth({
    "path": `csv-schemas/${key}/download-template`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Lookup Table
export function getViewManageLookupTables(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-lookup-tables`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathLookupTables(tableId=null) {
  if (tableId) {
      return `lookup-tables/${tableId}`;
  } else {
      return `lookup-tables`;
  }
}

export function createLookupTables(successCallback, errorCallback, data) {
  postAuth({
    "path": pathLookupTables(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchLookupTables(successCallback, errorCallback, data, tableId) {
  patchAuth({
    "path": pathLookupTables(tableId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteLookupTables(successCallback, errorCallback, tableId) {
  deleteAuth({
    "path": pathLookupTables(tableId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function urlUploadLookupTableRecords(tableId) {
  return `/${constants.API_VERSION}/lookup-tables/${tableId}/upload-records`;
}


export function exportLookupTableRecords(successCallback, errorCallback, tableId) {
  postAuth({
    "path": `lookup-tables/${tableId}/export-records`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Lookup Table Column
export function getViewManageLookupTableColumns(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-lookup-table-columns`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathLookupTableColumns(columnId=null) {
  if (columnId) {
      return `lookup-table-columns/${columnId}`;
  } else {
      return `lookup-table-columns`;
  }
}

export function createLookupTableColumns(successCallback, errorCallback, data) {
  postAuth({
    "path": pathLookupTableColumns(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchLookupTableColumns(successCallback, errorCallback, data, columnId) {
  patchAuth({
    "path": pathLookupTableColumns(columnId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteLookupTableColumns(successCallback, errorCallback, columnId) {
  deleteAuth({
    "path": pathLookupTableColumns(columnId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function reorderLookupTableColumns(successCallback, errorCallback, data, columnId) {
  postAuth({
    "path": `lookup-table-columns/${columnId}/reorder`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}



// Lookup Table Record
export function getViewManageLookupTableRecords(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-lookup-table-records`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathLookupTableRecords(recordId=null) {
  if (recordId) {
      return `lookup-table-records/${recordId}`;
  } else {
      return `lookup-table-records`;
  }
}

export function createLookupTableRecords(successCallback, errorCallback, data) {
  postAuth({
    "path": pathLookupTableRecords(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchLookupTableRecords(successCallback, errorCallback, data, recordId) {
  patchAuth({
    "path": pathLookupTableRecords(recordId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteLookupTableRecords(successCallback, errorCallback, recordId) {
  deleteAuth({
    "path": pathLookupTableRecords(recordId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Formula
export function postTestFormulas(successCallback, errorCallback, data) {
  postAuth({
    "path": `formulas/test`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}


// Taxonomy
export function getViewManageTaxonomies(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-taxonomies`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageTaxonomyRecords(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-taxonomy-records`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}
